import { Box, Grid, Link, Typography } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";
import { navigationData } from "../assets/commonComponents/data";
import { Facebook, Instagram, LinkedIn, XIcon } from "../assets/commonComponents/images";
import companyLogo from "../assets/images/logo-white-removebg-preview.png";
import { KnowledgeBaseContext } from "./knowledgeBaseContext/KnowledgeBaseContext";

const Footer = ({ data, mediaData, companyInfo, handleScroll }) => {
  const navigate = useNavigate();
  const {setSearchString}=useContext(KnowledgeBaseContext)

  return (
    <Box sx={{ bgcolor: COLORS.secondaryColor, color: "white", p: { xs: 3, md: 6 } }}>
      <Grid container spacing={4} alignItems="flex-start">
        {/* Logo */}
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Box display="flex" justifyContent={{ xs: "center", md: "flex-start" }}>
            <img src={companyLogo} alt="Company Logo" width="150" style={{ maxWidth: "100%", height: "auto" }} />
          </Box>
        </Grid>

        {/* Contact Info */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography color={COLORS.primaryColor} fontFamily={fontFamilyAll} gutterBottom>
            {companyInfo.phoneHeading}
          </Typography>
          <Typography variant="h6" fontFamily={fontFamilyAll}>
            {companyInfo.phone}
          </Typography>

          <Typography sx={{ mt: 2 }} color={COLORS.primaryColor} fontFamily={fontFamilyAll} gutterBottom>
            {companyInfo.addressHeading}
          </Typography>
          <Typography variant="h6" fontFamily={fontFamilyAll}>
            {companyInfo.address}
          </Typography>
        </Grid>

        {/* Knowledge Base */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: "white", mb: 2, fontFamily: fontFamilyAll }}
          >
            Knowledge Base
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: fontFamilyAll, mb: 1 }}>
            Explore our collection of articles and resources to stay informed.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: fontFamilyAll,
              color: "white",
              cursor: "pointer",
              fontWeight: "bold",
              "&:hover": { color: COLORS.primaryColor },
            }}
            onClick={() => {navigate("/knowledgebase")
                            setSearchString("")

            }}
          >
            View Knowledge Base →
          </Typography>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 ,fontFamily:fontFamilyAll}}>
            Quick Links
          </Typography>
          {navigationData.map((text, index) => (
            <Typography
              key={index}
              variant="body2"
              onClick={() => handleScroll(text?.toLowerCase())}
              sx={{
                mt: 1,
                transition: "color 0.3s",
                cursor: "pointer",
                "&:hover": { color: COLORS.primaryColor },
                "&:active": { color: COLORS.primaryColor },
              }}
              fontFamily={fontFamilyAll}
            >
              {text}
            </Typography>
          ))}
        </Grid>
      </Grid>

      {/* Bottom Section */}
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid gray",
          pt: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" fontFamily={fontFamilyAll}>
          {data}
        </Typography>

        <Box sx={{ mt: { xs: 2, sm: 0 }, display: "flex", justifyContent: "center" }}>
          {mediaData.map((link, index) => {
            const IconComponent = { Facebook, LinkedIn, XIcon, Instagram }[link.icon];
            return (
              <Link
                key={index}
                href={link.href}
                target="_blank"
                color="inherit"
                sx={{
                  mx: 1.5,
                  "&:hover": { color: COLORS.primaryColor },
                }}
                aria-label={link.label}
              >
                <IconComponent style={{ fontSize: 28 }} />
              </Link>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
